import { render, staticRenderFns } from "./RelatorioLAI.vue?vue&type=template&id=3073c6ae&"
import script from "./RelatorioLAI.vue?vue&type=script&lang=js&"
export * from "./RelatorioLAI.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports